import * as React from "react";
import type { SVGProps } from "react";
const SvgLiftChairSide = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#lift-chair-side_svg__a)">
      <path d="M12 19.5h-1.42c-1.61 0-3.08-1.43-3.08-3V12c0-2.11 1.84-3.96 3.96-4l-.04-3.09c0-.55.44-1 .99-1.01a.984.984 0 0 1 1.01.99L13.47 9c0 .27-.1.52-.29.71a1 1 0 0 1-.71.3h-.95c-1.02 0-2.03.99-2.03 2v4.5c0 .48.56 1 1.08 1h1.42c.55 0 1 .45 1 1s-.45 1-1 1z" />
      <path d="M8 6.5c-.43 0-.83-.28-.96-.72a.994.994 0 0 1 .68-1.24l8.5-2.5a.994.994 0 0 1 1.24.68.994.994 0 0 1-.68 1.24l-8.5 2.5c-.09.03-.19.04-.28.04M14 19.5h-2.5c-1.08 0-2-.92-2-2V14c0-.55.45-1 1-1s1 .45 1 1v3.5H14c.55 0 1 .45 1 1s-.45 1-1 1" />
      <path d="M15.5 22H14c-.55 0-1-.45-1-1v-4.5H8.5c-.55 0-1-.45-1-1s.45-1 1-1H14c.55 0 1 .45 1 1V20h.5c.55 0 1 .45 1 1s-.45 1-1 1" />
    </g>
    <defs>
      <clipPath id="lift-chair-side_svg__a">
        <path fill="#fff" d="M7 2h10.5v20H7z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLiftChairSide;
